<div class="search-message-box mt-2 mt-md-0"
     *ngIf="searchResult && searchResult.searchMessageBox && searchResult.searchMessageBox.displayMessage"
     [ngClass]="{'row': searchResult.highlightedEntity}">
  <div class="container search-message-box-container">
    <div class="row">
      <div class="col-auto search-message-box-enveloping-col">
        <div class="row">
            <div class="col-2 col-sm-auto search-message-box-left-col">
              <svg-icon key="info" width="32px" height="32px"></svg-icon>
            </div>
            <div class="col col-sm-auto search-message-box-right-col">
              <span class="search-message-box-headline" [innerHTML]="searchResult.searchMessageBox.headline"></span>
              <div class="search-message-box-url-list" *ngIf="searchResult.searchMessageBox.namedSearchParams">
                <ng-container *ngIf="searchResult">
                  <ng-container
                    *ngFor="let namedParam of searchResult.searchMessageBox.namedSearchParams; last as isLast">
                    <a (click)="triggerSearch(namedParam.searchParams)">{{ namedParam.displayString }}</a>
                    <span *ngIf="!isLast" class="search-message-box-separator"> | </span>
                  </ng-container>
                </ng-container>
              </div>
              <div class="search-message-box-url"
                   *ngIf="searchResult.searchMessageBox.url">
                <span
                  [innerHTML]="searchResult.searchMessageBox.detailsBeforeTheUrl + '&nbsp;'"></span>
                <a [href]="searchResult.searchMessageBox.url.url">
                  {{ searchResult.searchMessageBox.url.displayString }}
                </a>
              </div>
            </div>
        </div>
      </div>
    </div>
  </div>
</div>
